import {
  forwardRef,
  type InputHTMLAttributes,
  type ReactNode,
  type TextareaHTMLAttributes,
} from "react";

import { cx } from "./cx";
import styles from "./input.module.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  leadingIcon?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, leadingIcon, ...props }, ref) => (
    <div className={styles.wrapper}>
      {leadingIcon ? (
        <div className={styles.leadingIcon}>{leadingIcon}</div>
      ) : null}
      <input
        ref={ref}
        className={cx(
          styles.input,
          !!leadingIcon && styles.leading,
          error && styles.error,
          className,
        )}
        {...props}
      />
    </div>
  ),
);
Input.displayName = "Input";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cx(styles.textarea, error && styles.error, className)}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
